/* =========================================================
   PÁGINA DO MULTI, VERSÃO B — sections/cb-pdp-compra.liquid
   Kits: troca o kit escolhido e atualiza preços, botão e barra fixa.
   O "Adicionar ao carrinho" é o mesmo do tema (assets/cb-primeira-compra.js, atributo data-pc-add),
   que usa a gaveta do carrinho do próprio tema.
   ========================================================= */
(function () {
  'use strict';

  const root = document.querySelector('[data-cbp-buy]');
  if (!root) return;

  /* ---------- Kits ---------- */
  const kits = Array.from(root.querySelectorAll('[data-cbp-kit]'));
  const binds = Array.from(document.querySelectorAll('[data-cbp-bind]'));
  const addButtons = Array.from(document.querySelectorAll('[data-cbp-add]'));
  const stickyBtn = document.querySelector('[data-cbp-sticky-btn]');
  const kitsFieldset = root.querySelector('.cbp-kits');
  const idInput = root.querySelector('[data-cbp-id]');
  let hasChosenKit = false;

  function select(kit, userInteracted) {
    if (userInteracted) {
      hasChosenKit = true;
    }
    kits.forEach((k) => {
      const on = k === kit;
      k.classList.toggle('is-on', on);
      k.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    binds.forEach((el) => {
      const value = kit.dataset[el.dataset.cbpBind];
      if (value != null) el.textContent = value;
    });
    addButtons.forEach((btn) => btn.setAttribute('data-pc-add', kit.dataset.variant));
    if (idInput) idInput.value = kit.dataset.variant;

    if (stickyBtn) {
      if (hasChosenKit) {
        stickyBtn.setAttribute('data-pc-add', kit.dataset.variant);
        stickyBtn.textContent = `Adicionar · ${kit.dataset.label}`;
      } else {
        stickyBtn.removeAttribute('data-pc-add');
        stickyBtn.textContent = 'Escolher kit';
      }
    }
  }

  kits.forEach((kit) => {
    kit.addEventListener('click', () => {
      if (!kit.disabled) select(kit, true);
    });
  });

  function showKits() {
    if (!kitsFieldset) return;
    kitsFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    kitsFieldset.classList.remove('is-highlighted');
    void kitsFieldset.offsetWidth;
    kitsFieldset.classList.add('is-highlighted');
    setTimeout(() => kitsFieldset.classList.remove('is-highlighted'), 1800);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      if (!hasChosenKit) {
        e.preventDefault();
        e.stopPropagation();
        showKits();
      }
    });
  }

  // Botões das seções de baixo ("O que muda", "90 dias"): data-cbp-pick-kit="3" marca o kit 3; vazio só leva aos kits
  document.querySelectorAll('[data-cbp-pick-kit]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const kit = kits[Number(btn.dataset.cbpPickKit) - 1];
      if (kit && !kit.disabled) select(kit, true);
      showKits();
    });
  });

  /* ---------- Galeria ---------- */
  const track = root.querySelector('[data-cbp-track]');
  const slides = track ? Array.from(track.children) : [];
  const dots = Array.from(root.querySelectorAll('[data-cbp-dot]'));
  const thumbs = Array.from(root.querySelectorAll('[data-cbp-thumb]'));
  const count = root.querySelector('[data-cbp-count]');

  function mark(index) {
    dots.forEach((d, i) => d.classList.toggle('is-on', i === index));
    thumbs.forEach((t, i) => {
      t.classList.toggle('is-on', i === index);
      t.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    if (count) count.textContent = `${index + 1} / ${slides.length}`;
  }

  // No celular cada foto ocupa 84% da largura (a próxima aparece na borda): o passo é a distância entre duas fotos
  const step = () => (slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth) || 1;

  if (track && slides.length) {
    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          mark(Math.min(slides.length - 1, Math.round(track.scrollLeft / step())));
          ticking = false;
        });
      },
      { passive: true }
    );
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
        mark(i);
      });
    });
  }

  /* ---------- Barra fixa: aparece sempre que o botão principal está fora da tela ----------
     Com as fotos grandes, o botão fica abaixo da primeira tela no celular; a barra mantém a compra visível desde o início. */
  const sticky = document.querySelector('[data-cbp-sticky]');
  const mainBtn = root.querySelector('[data-cbp-main-add]');
  const whatsapp = () => document.getElementById('whatsapp-button') || document.querySelector('.whatsapp-button');

  function showSticky(visible) {
    if (!sticky) return;
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) sticky.removeAttribute('inert');
    else sticky.setAttribute('inert', '');
    const wa = whatsapp();
    if (wa) {
      wa.style.transition = 'bottom 0.25s ease';
      wa.style.bottom = visible ? `${sticky.offsetHeight + 12}px` : '';
    }
  }

  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      ([entry]) => showSticky(!entry.isIntersecting),
      { threshold: 0 }
    ).observe(mainBtn);
  }
})();
